require('./helpers/bundle-manifest').register(JSON.parse("{\"1dCZJ\":\"index.js\",\"1Wsxb\":\"serviceworker.js\"}"));